import { Question, ContentItem, TextContentItem, VideoContentItem,
         DividerContentItem, ImageContentItem } from '.';

export class Lesson {
  id: number;
  title: string;
  description: string;
  contentItems: ContentItem[] = [];
  questions: Question[] = [];
  lastModified: Date;

  constructor(json: any) {
    if (json) {
      this.updateLesson(json);
      if (json.id) this.id = json.id;
      if (json.updated_at) this.lastModified = new Date(json.updated_at);
    }
  }

  toJson() {
    let json = {
      title: this.title,
      description: this.description,
      last_modified: this.lastModified.toJSON(),
      content: this.contentItems.map(contentItem => contentItem.toJson()),
      questions: this.questions.map(question => question.toJson())
    };
    if (this.id) json['id'] = this.id;
    return json;
  }

  updateLesson(json: any) {
    if (json.title) this.title = json.title;
    if (json.description) this.description = json.description;
    if (json.questions) this.updateLessonQuestionsWithJson(json.questions);
    if (json.content) this.updateLessonContentWithJson(json.content);
    this.lastModified = new Date();
  }

  updateLessonQuestionsWithJson(questionsJson: any[]) {
    this.questions = questionsJson.map(questionJson => {
      return new Question(questionJson);
    })
  }

  updateLessonContentWithJson(contentItemsJson: any[]) {
    this.contentItems = contentItemsJson.map(itemJson => {
      switch(itemJson.content_type) {
        case 'text':
          return new TextContentItem(itemJson);
        case 'youtube-video':
        case 'video':
          return new VideoContentItem(itemJson);
        case 'divider':
          return new DividerContentItem();
        case 'image':
          return new ImageContentItem(itemJson);
        default:
          return;
      }
    })
  }

  updateLessonContent(contentItems: ContentItem[]) {
    this.contentItems = contentItems;
  }

  updateLessonQuestions(questions: Question[]) {
    this.questions = questions;
  }

  addContent(json: any) {
    if (json.content_type) {
      this.contentItems.push(json);
    }
  }

  removeContent(json: any) {
    let index = this.contentItems.indexOf(json);
    if (index > -1) this.contentItems.splice(index, 1);
  }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/lesson.model.ts